module.exports = __webpack_public_path__ + "static/media/CTLI_15-147w.1b9abbd6.webp";